export default {
  getLocale: state => {
    return state.locale
  },
  getLang: state => {
    return state.currentLanguage
  },
  getCurrency: state => {
    return state.selectedCurrency
  },
  getCurrencyName: state => {
    return state.selectedCurrencyName
  },
  getLoggedIn: state => {
    return state.loggedin
  },
  getDomain: state => {
    return state.domain
  },
  getContainerClass: state => {
    return state.containerClass
  },
  getLayout (state) {
    return state.layout
  },
  getPredectiveData (state) {
    return state.predectiveData
  },
  getAirSearchRQ: state => {
    return state.air.searchRQ
  },
  getAirSearchRS: state => {
    return state.air.searchRS
  },
  getAirReviewRS: state => {
    return state.air.reviewRS
  },
  getAirPriceRS: state => {
    return state.air.priceRS
  },
  getAirPNRRS: state => {
    return state.air.pnrRS
  },
  getAirTicketRS: state => {
    return state.air.ticketRS
  },
  getTravellers:state => {
    return state.travellers
  },
  getModify:state => {
    return state.modify
  },
  getCustomerData:state => {
    return state.customerData
  },
  getAuth:state => {
    return state.auth
  }
}



// WEBPACK FOOTER //
// src/store/getters.js